import { APIClient } from "api/api_helper";
import { VOLUNTEER_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const volunteerAssignmentApiService = {

    // -----------------------------
    // SELECT ALL
    // -----------------------------
    getSelectAllData: (
        studyId?: number | null,
        searchText?: string | null,
        pageNumber: number = 1,
        pageSize: number = 10,
  
        assignmentstatus?: string | null,
    ) => {
        const payload = {
            studyid: studyId ?? null,
            searchtext: searchText ?? null,
            status: "A",
            currentpage: pageNumber,
            pagesize: pageSize,
           
            assignmentstatus: assignmentstatus ?? null,
        };
        return api.create(
            VOLUNTEER_API.VOLUNTEER_ASSIGNMENT_API + "SelectAll",
            payload
        );
    },

    // -----------------------------
    // INSERT
    // -----------------------------
    insertData: (payload_data: {
        volunteerid: number;
        studyid: number;
    }) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            volunteerid: payload_data.volunteerid,
            studyid: payload_data.studyid,
            createdby: user.userid,
            
            
        };

        return api.create(
            VOLUNTEER_API.VOLUNTEER_ASSIGNMENT_API + "Insert",
            payload
        );
    },

    // -----------------------------
    // UPDATE
    // -----------------------------
    updateData: (payload_data: {
        volunteerid: number;
        volunteerassignmentid: number;
        studyid: number,
        subjectno: number,
        assignments: []
    }) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            volunteerid: payload_data.volunteerid,
            volunteerassignmentid: payload_data.volunteerassignmentid,
            studyid: payload_data.studyid,
            updatedby: user.userid,
            assignments: payload_data.assignments,
            
            
            subjectno: payload_data.subjectno
        };

        return api.create(
            VOLUNTEER_API.VOLUNTEER_ASSIGNMENT_API + "Update",
            payload
        );
    },


    // -----------------------------
    // DELETE
    // -----------------------------
    deleteData: (payload_data: {
        volunteerid: number | null;
        updatereason: string;
    }) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            volunteerassignmentid: payload_data.volunteerid,
            updatedby: user.userid,
            updatereason: payload_data.updatereason,
            
            
        };

        return api.create(
            VOLUNTEER_API.VOLUNTEER_ASSIGNMENT_API + "Delete",
            payload
        );
    },

    // -----------------------------
    // LOG INSERT
    // -----------------------------
    loginsert: (payload_data: {
        volunteerassignmentid: number | null;
        studyid: number | null;
    }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            
            
            printby: user.userid,
            volunteerassignmentid: payload_data.volunteerassignmentid,
            studyid: payload_data.studyid,
        };

        return api.create(
            VOLUNTEER_API.VOLUNTEER_ASSIGNMENT_API + "LogInsert",
            payload
        );
    },

    logbulkinsert: (payload_data: {
        studyid: number | null;
    }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            
            
            printby: user.userid,
            studyid: payload_data.studyid,
        };

        return api.create(
            VOLUNTEER_API.VOLUNTEER_ASSIGNMENT_API + "LogBulkInsert",
            payload
        );
    },

    getSelectLogData: (
        volunteerassignmentid?: number | null,
        searchText?: string | null,
        pageNumber: number = 1,
        pageSize: number = 10,

    ) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            // otherid: otherid ?? 0,
            currentpage: pageNumber,
            pagesize: pageSize,
            volunteerassignmentid: volunteerassignmentid ?? null,
            
            
        };

        return api.create(
            VOLUNTEER_API.VOLUNTEER_ASSIGNMENT_API + "LogSelect",
            payload
        );
    }
};
